import { SFX } from './sounds';

/**
 * Sons do disparo e da explosão de cada bomba: `ShootSound` e `BombSound` do `BallList.xml` do legado (`BallInfo`). O id é o mesmo que o cliente original passava a
 * `SoundManager.instance.play("116")` e vira `audio/sfx/<id>.mp3`. O legado toca o disparo no instante em que o projétil sai (`ShootAction`) e a explosão quando a
 * bomba bate (`SimpleBomb.bomb`). Som que não existe no pacote de áudio (a explosão `166` das bombas 281 a 284 e 291 a 294) fica mudo, como no original.
 */
const BALL_SOUNDS: Readonly<Record<number, readonly [shoot: string, bomb: string]>> = {
  0: ['023', '096'],
  1: ['023', '093'],
  3: ['023', '096'],
  4: ['069', '088'],
  6: ['023', '087'],
  7: ['023', '093'],
  8: ['023', '093'],
  9: ['023', '087'],
  10: ['023', '093'],
  18: ['021', '094'],
  19: ['073', '094'],
  20: ['033', '095'],
  21: ['075', '095'],
  22: ['031', '087'],
  23: ['071', '088'],
  26: ['033', '095'],
  27: ['075', '095'],
  28: ['033', '095'],
  29: ['075', '095'],
  30: ['031', '087'],
  31: ['071', '088'],
  32: ['023', '087'],
  33: ['023', '087'],
  34: ['073', '094'],
  35: ['116', '107'],
  36: ['116', '107'],
  37: ['115', '106'],
  38: ['116', '107'],
  42: ['021', '094'],
  43: ['073', '094'],
  44: ['075', '095'],
  45: ['031', '087'],
  46: ['029', '089'],
  47: ['079', '090'],
  48: ['115', '106'],
  49: ['113', '105'],
  50: ['021', '094'],
  51: ['073', '094'],
  52: ['073', '094'],
  53: ['033', '095'],
  54: ['115', '106'],
  55: ['113', '105'],
  56: ['075', '095'],
  57: ['031', '087'],
  58: ['115', '106'],
  59: ['023', '093'],
  61: ['109', '099'],
  62: ['111', '103'],
  63: ['112', '104'],
  64: ['023', '093'],
  65: ['108', '098'],
  68: ['116', '107'],
  69: ['113', '105'],
  72: ['069', '088'],
  73: ['114', '101'],
  74: ['021', '094'],
  75: ['073', '094'],
  76: ['029', '089'],
  77: ['079', '090'],
  78: ['115', '106'],
  79: ['108', '098'],
  80: ['025', '087'],
  81: ['', '088'],
  83: ['', '152'],
  84: ['154', '152'],
  85: ['029', '152'],
  86: ['079', '090'],
  87: ['035', '091'],
  96: ['081', '092'],
  101: ['023', '087'],
  102: ['023', '087'],
  103: ['023', '087'],
  104: ['023', '087'],
  111: ['069', '088'],
  112: ['069', '088'],
  113: ['069', '088'],
  114: ['069', '088'],
  121: ['029', '089'],
  122: ['029', '089'],
  123: ['029', '089'],
  124: ['029', '089'],
  131: ['079', '090'],
  132: ['079', '090'],
  133: ['079', '090'],
  134: ['079', '090'],
  141: ['035', '091'],
  142: ['035', '091'],
  143: ['035', '091'],
  144: ['035', '091'],
  151: ['081', '092'],
  152: ['081', '092'],
  153: ['081', '092'],
  154: ['081', '092'],
  161: ['025', '087'],
  162: ['025', '087'],
  163: ['025', '087'],
  164: ['025', '087'],
  171: ['083', '088'],
  172: ['083', '088'],
  173: ['083', '088'],
  174: ['083', '088'],
  221: ['111', '103'],
  222: ['111', '103'],
  223: ['111', '103'],
  231: ['112', '104'],
  232: ['112', '104'],
  233: ['112', '104'],
  241: ['023', '087'],
  242: ['023', '087'],
  243: ['023', '087'],
  251: ['069', '088'],
  252: ['069', '088'],
  253: ['069', '088'],
  261: ['116', '107'],
  262: ['116', '107'],
  263: ['116', '107'],
  271: ['113', '105'],
  272: ['113', '105'],
  273: ['113', '105'],
  281: ['021', '166'],
  282: ['021', '166'],
  283: ['021', '166'],
  284: ['021', '166'],
  291: ['073', '166'],
  292: ['073', '166'],
  293: ['073', '166'],
  294: ['073', '166'],
  321: ['110', '100'],
  322: ['110', '100'],
  323: ['110', '100'],
  324: ['110', '100'],
  331: ['109', '099'],
  332: ['109', '099'],
  333: ['109', '099'],
  334: ['109', '099'],
  341: ['111', '103'],
  342: ['111', '103'],
  343: ['111', '103'],
  344: ['111', '103'],
  351: ['112', '104'],
  352: ['112', '104'],
  353: ['112', '104'],
  354: ['112', '104'],
  361: ['115', '106'],
  362: ['115', '106'],
  363: ['115', '106'],
  364: ['115', '106'],
  371: ['108', '098'],
  372: ['108', '098'],
  373: ['108', '098'],
  374: ['108', '098'],
  381: ['116', '107'],
  382: ['116', '107'],
  383: ['116', '107'],
  384: ['116', '107'],
  391: ['113', '105'],
  392: ['113', '105'],
  393: ['113', '105'],
  394: ['113', '105'],
  401: ['114', '102'],
  402: ['114', '102'],
  403: ['114', '102'],
  404: ['114', '102'],
  411: ['114', '101'],
  412: ['114', '101'],
  413: ['114', '101'],
  414: ['114', '101'],
  461: ['029', '089'],
  462: ['029', '089'],
  463: ['029', '089'],
  464: ['029', '089'],
  471: ['079', '090'],
  472: ['079', '090'],
  473: ['079', '090'],
  474: ['079', '090'],
  481: ['115', '106'],
  482: ['115', '106'],
  483: ['115', '106'],
  484: ['115', '106'],
  491: ['113', '105'],
  492: ['113', '105'],
  493: ['113', '105'],
  494: ['113', '105'],
  661: ['116', '107'],
  662: ['116', '107'],
  663: ['116', '107'],
  664: ['116', '107'],
  671: ['123', '122'],
  672: ['123', '122'],
  673: ['123', '122'],
  674: ['123', '122'],
  701: ['116', '107'],
  702: ['116', '107'],
  703: ['116', '107'],
  704: ['116', '107'],
  711: ['113', '105'],
  712: ['113', '105'],
  713: ['113', '105'],
  714: ['113', '105'],
  881: ['109', '099'],
  882: ['109', '099'],
  883: ['109', '099'],
  884: ['109', '099'],
  891: ['079', '090'],
  901: ['114', '101'],
  902: ['114', '101'],
  903: ['114', '101'],
  904: ['114', '101'],
  911: ['083', '088'],
  912: ['083', '088'],
  913: ['083', '088'],
  914: ['083', '088'],
  921: ['108', '098'],
  922: ['108', '098'],
  923: ['108', '098'],
  924: ['108', '098'],
  931: ['123', '122'],
  932: ['123', '122'],
  933: ['123', '122'],
  934: ['123', '122'],
  941: ['108', '098'],
  942: ['108', '098'],
  943: ['108', '098'],
  944: ['108', '098'],
  951: ['113', '105'],
  952: ['113', '105'],
  953: ['113', '105'],
  954: ['113', '105'],
  971: ['113', '105'],
  972: ['113', '105'],
  973: ['113', '105'],
  974: ['113', '105'],
  1011: ['023', '087'],
  1012: ['023', '087'],
  1021: ['023', '087'],
  1022: ['023', '087'],
  1031: ['023', '087'],
  1032: ['023', '087'],
  1041: ['023', '087'],
  1042: ['023', '087'],
  1211: ['029', '089'],
  1212: ['029', '089'],
  1221: ['029', '089'],
  1222: ['029', '089'],
  1231: ['029', '089'],
  1232: ['029', '089'],
  1241: ['029', '089'],
  1242: ['029', '089'],
  1411: ['035', '091'],
  1412: ['035', '091'],
  1421: ['035', '091'],
  1422: ['035', '091'],
  1431: ['035', '091'],
  1432: ['035', '091'],
  1441: ['035', '091'],
  1442: ['035', '091'],
  1611: ['025', '087'],
  1612: ['025', '087'],
  1621: ['025', '087'],
  1622: ['025', '087'],
  1631: ['025', '087'],
  1632: ['025', '087'],
  1641: ['025', '087'],
  1642: ['025', '087'],
  2211: ['111', '103'],
  2212: ['111', '103'],
  2221: ['111', '103'],
  2222: ['111', '103'],
  2231: ['111', '103'],
  2232: ['111', '103'],
  2411: ['023', '087'],
  2412: ['023', '087'],
  2421: ['023', '087'],
  2422: ['023', '087'],
  2431: ['023', '087'],
  2432: ['023', '087'],
  2611: ['116', '107'],
  2612: ['116', '107'],
  2621: ['116', '107'],
  2622: ['116', '107'],
  2631: ['116', '107'],
  2632: ['116', '107'],
  2811: ['021', '167'],
  2812: ['021', '166'],
  2821: ['021', '167'],
  2822: ['021', '166'],
  2831: ['021', '167'],
  2832: ['021', '166'],
  2841: ['021', '167'],
  2842: ['021', '166'],
  3211: ['110', '100'],
  3212: ['110', '100'],
  3221: ['110', '100'],
  3222: ['110', '100'],
  3231: ['110', '100'],
  3232: ['110', '100'],
  3241: ['110', '100'],
  3242: ['110', '100'],
  3411: ['111', '103'],
  3412: ['111', '103'],
  3421: ['111', '103'],
  3422: ['111', '103'],
  3431: ['111', '103'],
  3432: ['111', '103'],
  3441: ['111', '103'],
  3442: ['111', '103'],
  3611: ['115', '106'],
  3612: ['115', '106'],
  3621: ['115', '106'],
  3622: ['115', '106'],
  3631: ['115', '106'],
  3632: ['115', '106'],
  3641: ['115', '106'],
  3642: ['115', '106'],
  3811: ['116', '107'],
  3812: ['116', '107'],
  3821: ['116', '107'],
  3822: ['116', '107'],
  3831: ['116', '107'],
  3832: ['116', '107'],
  3841: ['116', '107'],
  3842: ['116', '107'],
  4011: ['114', '102'],
  4012: ['114', '102'],
  4021: ['114', '102'],
  4022: ['114', '102'],
  4031: ['114', '102'],
  4032: ['114', '102'],
  4041: ['114', '102'],
  4042: ['114', '102'],
  4611: ['029', '089'],
  4612: ['029', '089'],
  4621: ['029', '089'],
  4622: ['029', '089'],
  4631: ['029', '089'],
  4632: ['029', '089'],
  4641: ['029', '089'],
  4642: ['029', '089'],
  4811: ['115', '106'],
  4812: ['115', '106'],
  4821: ['115', '106'],
  4822: ['115', '106'],
  4831: ['115', '106'],
  4832: ['115', '106'],
  4841: ['115', '106'],
  4842: ['115', '106'],
  6611: ['116', '107'],
  6612: ['116', '107'],
  6621: ['116', '107'],
  6622: ['116', '107'],
  6631: ['116', '107'],
  6632: ['116', '107'],
  6641: ['116', '107'],
  6642: ['116', '107'],
  7011: ['116', '107'],
  7012: ['116', '107'],
  7021: ['116', '107'],
  7022: ['116', '107'],
  7031: ['116', '107'],
  7032: ['116', '107'],
  7041: ['116', '107'],
  7042: ['116', '107'],
};

/** Som do disparo da bomba; sem a bomba na tabela, o par padrão antigo. */
export function shootSoundOf(ballId: number): string {
  return BALL_SOUNDS[ballId]?.[0] ?? SFX.shoot;
}

/** Som da explosão da bomba; sem a bomba na tabela, o par padrão antigo. */
export function bombSoundOf(ballId: number): string {
  return BALL_SOUNDS[ballId]?.[1] ?? SFX.bomb;
}
